import { useAuthStore } from '@/stores/auth';

// Shutdown form export (#6223), driven by tools/form-pdf-export. Delete with the tool.
export default [
    {
        path: 'system/form-export',
        name: 'form-export',
        component: () => import('../views/FormExportPage.vue'),
        beforeEnter: () => {
            if (!useAuthStore().isBnSupport) return { name: 'home' };
        },
    },
];
